import React from 'react'

export default function About() {
  return (
    <div className="mainpage">About</div>
  )
}
